
import { defineComponent, PropType } from 'vue'
interface PropDetail {
  name: string;
  type: string;
  desc: string;
  default?: string;
}
export default defineComponent({
  props: {
    props: {
      type: Array as PropType<PropDetail[]>,
      required: true
    }
  }
})
